export const initialState = {
  streamingTranscriptionEnabled: false,
};

export default (state = initialState): typeof initialState => {
  return state;
};
